<section class="team-hero-area fixed-height parallaxBg bg-img" data-bg="assets/img/fondo2.jpg"
    style="background-image: none;"
    data-jarallax-original-styles="background-image: url(&quot;assets/img/fondo2.jpg&quot;);">
    <div class="container h-100">
        <div class="row team-member-item h-100">
            <div class="col-lg-7 text-center m-auto">
                <div class="about-us-content white mt-70 mt-sm-50">
                    <h2 style="font-size: 35px; margin-bottom: 0px; line-height: 1.4;">Gerencia del Centro Histórico</h2>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="contact-content-area mt-120 mt-md-80 mt-sm-60 mb-120 mb-md-80 mb-sm-54"  style="background-image: url('/assets/img/gerencia/fondo-gerencia.png'); background-size: cover;
    background-position: center;">
  <div class="container">
    <div class="row">
      <div class="col-md-6 col-lg-7">
        <!-- Start Contact Form Area -->
        <div class="contact-form-area-wrapper">
          <div class="area-title mb-44">
            <h2 class="mb-8">Envianos un mensaje</h2>
          </div>
          <div class="contact-form-wrapper">
            <form action="contact_me.php" method="post" id="contact-form">
              <div class="form-input-item">
                <input type="text" name="con_name" placeholder="Tu nombre (requerido)*" required="" />
              </div>
              <div class="form-input-item">
                <input type="email" name="con_email" placeholder="Tu Email (requerido)*" required=""  />
              </div>
              <div class="form-input-item">
                <textarea name="con_message" id="message" cols="30" rows="10" placeholder="Tu mensaje (requerido)*" ></textarea>
              </div>
              <div class="form-input-item">
                <button type="submit" class="btn btn-black">Enviar Mensaje</button>
              </div>
              <!-- Show Message Notification -->
              <div class="form-message"></div>
            </form>
          </div>
        </div>
        <!-- End Contact Form Area -->
      </div>
      <div class="col-md-6 col-lg-5">
        <!-- Start Contact Info Area -->
        <div class="contact-info-area mt-sm-50">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3879.360358420384!2d-71.98018918460401!3d-13.513463090502063!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x916dd7f071c1e139%3A0x6424a302c3d64e51!2sGerencia%20de%20Centro%20Hist%C3%B3rico!5e0!3m2!1ses-419!2sus!4v1628709299338!5m2!1ses-419!2sus"
          width="100%" height="400" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
          <div class="contact-info-wrap text-center mt-50 mt-md-30">
            <p class="mb-30 mb-md-20">
              <strong>Calle Pumakurko 470<br />Cusco - Perú</strong>
            </p>
            <p class="m-0">
              <strong>Teléfono:  986428724<br />Email: centro.historico@cusco.gob.pe</strong>
            </p>
          </div>
        </div>
        <!-- End Contact Info Area -->
      </div>
    </div>
  </div>
</section>
